import {Navigate, useLocation} from 'react-router-dom'
import {getItemFromStorage} from 'utils/storage'

const AdminRoute = ({children}) => {
  const location = useLocation()
  const user = getItemFromStorage({name: 'user'})
  const profile = getItemFromStorage({name: 'profile'})

  if (!user) {
    return <Navigate to="/login" state={{from: location}} replace />
  }

  if (!profile?.isAdmin) {
    return <Navigate to="/homepage" replace />
  }

  return children
}

export default AdminRoute
